export default "__VITE_ASSET__D49mtgMk__"